import { sendPost } from '@utils/request';
// import { sendPost as sendPostBFD } from '@/utils/headerRequest';
import './order';
import './address';
import './logistics';
import './health';
import { unionFlag } from '@/utils';

export function getDetailData(data) {
  const url = '/trade/goods/findGoodsDetails';
  return sendPost({ url, data });
}

export function getUserMenuListBFD(data) {
  const url = '/user/menu/list';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

// 根据地址 skuid 获取 商品库存信息
export function getStockStatus(data) {
  const url = '/api/web/stock';
  return sendPost({ url, data });
}
// 获取商品信息
export function getProductInfo(data) {
  const url = '/trade/goods/findGoodsDetails';
  return sendPost({ url, data });
}

// 获取登录状态
// export const getLoginStatus = data =>
//   sendPost('/user/checkLogin', data, true);

// // 获取城市列表
// export const getCityList = data =>
//   sendPost('/location/citylist', data, true);

// // 快速搜索
// export const getQuickSearchResult = data =>
//   sendPost('/search/quick', data, true);

// // 获取公告
// export const getNotice = data =>
//   sendPost('/notice/noticeContent', data, true);

// Fill and Double Check Delivery Info
export function fetchFindByUnion(data) {
  const url = '/mallUnion/unionConfig/findByUnion';
  return sendPost({ url, data, Business: false });
}

// 获取union头部数据
export function fetchUnionLogo(data) {
  const url = '/mallunion/getLogo';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

export function fetchLifeIndex(data) {
  const url = '/trade/preferredLifeContract/getHomePageData';
  return sendPost({ url, data });
}

export function fetchProductListById(data) {
  const url = '/categoryGoods/getCategoryGoodsList';
  return sendPost({ url, data });
}

export function promotionGoods(data) {
  const url = '/api/promotion/goods/detail';
  return sendPost({ url, data });
}
export function getAds(data) {
  const url = '/api/ads/banner/getBanner';
  return sendPost({ url, data });
}

export function getBookAds(data) {
  const url = '/api/ads/banner/getBannerInfo';
  return sendPost({ url, data });
}

export function fetchAddList(data) {
  const url = '/categoryGoods/additionGoodsList';
  return sendPost({ url, data });
}

export function fetchRecentScan(data) {
  const url = '/trade/goods/recentlyViewed';
  return sendPost({ url, data });
}

export function fetchNavCategory(data) {
  const url = '/trade/index/getAllCategoryByChannel';
  return sendPost({ url, data });
}
export function fetchUnionScale(data) {
  const url = '/union/getunionconfig';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

// 获取工会菜单
export function getFindUsableList(data) {
  const url = '/mallUnion/unionMallConfig/findUsableList';
  return sendPost({ url, data });
}

export function getLogo(data) {
  const url = '/mallunion/getLogo';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}
// 获取商品标签
export function fetchGoodsTags(data) {
  const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
  if (unionF)
    data.unionId = unionF;
  const url = '/trade/promotion/tags';
  return sendPost({ url, data });
}

export function doValidate() {
  const url = '/oms/right/gray/validate';
  return sendPost({ url, data: {
    tagId: 200001,
    appCode: '100020',
  }, baseURL: true, applicationType: true });
}